var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"news-page"},[_vm._m(0),_c('News'),_c('HomeFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"news-center-hero"},[_c('div',{staticClass:"news-center-hero-inner"},[_c('h1',[_vm._v("新闻资讯")]),_c('div',{staticClass:"news-center-mark",attrs:{"aria-hidden":"true"}},[_c('i'),_c('i'),_c('i')])])])
}]

export { render, staticRenderFns }